import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Table from './Table';
import { useFetch } from '../../hooks/useFetch';
import TableLoading from '../Loading/TableLoading';
import API_ENDPOINTS from '../../api';

const OpinionManagement = () => {
  const [opinions, setOpinions] = useState([]);
  const navigate = useNavigate();

  const {
    data: opinionsData,
    loading,
    error,
  } = useFetch(API_ENDPOINTS.OPINIONS.GET_ALL);

  useEffect(() => {
    if (opinionsData && Array.isArray(opinionsData.opinion)) {
      setOpinions(opinionsData.opinion);
    }
  }, [opinionsData]);

  console.log("opinion " ,opinions);

  const handleUpdate = (id) => {
    navigate(`/admin/addOpinion/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(API_ENDPOINTS.OPINIONS.DELETE(id));
      setOpinions((prev) => prev.filter((op) => op._id !== id));
    } catch (err) {
      console.error('Failed to delete opinion:', err);
    }
  };

  if (loading) return <TableLoading />;

  return (
    <div>
      <h2 className="text-2xl font-extrabold text-primeColor mb-4 border-b-2 border-primeColor pb-2">
        Opinion Management
      </h2>

      <Link to="/admin/addOpinion">
        <button className="bg-secondColor text-white font-bold py-2 px-4 rounded mb-4 hover:opacity-90">
          Add Opinion
        </button>
      </Link>

      <Table
        headers={['text', 'rating', 'language', 'isNew', 'createdAt']}
        data={opinions.map((opinion) => ({
          _id: opinion._id,
          text: opinion.text.length > 60
            ? opinion.text.slice(0, 60) + '...'
            : opinion.text,
          rating: `${opinion.rating} ⭐`,
          language: opinion.language.toUpperCase(),
          isNew: opinion.isNew ? 'Yes' : 'No',
          createdAt: new Date(opinion.createdAt).toLocaleDateString(),
        }))}
        handleUpdate={handleUpdate} 
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default OpinionManagement;
